import './Wip.scss'

const Wip = () => {
    return (
        <>
          <div className="wip-img">
            <img src="./images/wip.png" alt="wip" />
        </div>
            
        </>
    )
}

export default Wip;
